import { Component } from 'react';
import ReactModal from '../../../components/Modal';
import { withTranslation } from 'react-i18next';

class ConfirmationModal extends Component {
    constructor() {
        super();
    }
    render() {
        const { t } = this.props;
        return (
            <ReactModal modalState={this.props.isOpen} className="width-md">
                <div className="manage-account-modal">
                    <div>{t('settings.add_account.header')}</div>
                    <img className="my-16" src="/static/img/google-scope-permissions2.png" />
                    <div className="d-flex justify-content-end gap-8">
                        <button
                            onClick={this.props.onClose}
                            className="button button-outline button-primary width-sm btn"
                        >
                            {t('settings.add_account.cancel')}
                        </button>
                        <a
                            href="/customers/link"
                            onClick={this.props.onClose}
                            className="button button-filled button-primary width-sm btn"
                        >
                            {t('settings.add_account.okay')}
                        </a>
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(ConfirmationModal);
